import { Button, Checkbox, Flex, SimpleGrid, TextInput } from '@mantine/core'
import { modals } from '@mantine/modals'

import createEmailDomainUseCase from '../../hook/createEmailDomian.hook'
import styles from './create-email-domiain-modal.module.scss'

const CreateEmailDomain = () => {
  const { onSubmit, form, isLoading } = createEmailDomainUseCase()
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <SimpleGrid cols={2} spacing="xl" verticalSpacing="xl">
        <TextInput
          key={form.key('domain')}
          label="Email Address - Domain"
          withAsterisk
          {...form.getInputProps('domain')}
        />
        <Checkbox
          className={styles['checkbox-center']}
          {...form.getInputProps('isWBFRegister')}
          key={form.key('isWBFRegister')}
          label="Is WBF Register"
        />
      </SimpleGrid>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button loading={isLoading} type="submit" variant="filled">
          Save
        </Button>
      </Flex>
    </form>
  )
}

export const createEmailDomainModal = () =>
  modals.open({
    title: 'Create Email Domiain',
    centered: true,
    children: <CreateEmailDomain />,
  })
